import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import QRcode from 'qrcode.react'

export default class GeneradorQR extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                url: '',
                descripcion: '',
            },
            colapsar: true,
            codigoQR: {},
            camposRequeridos: [],
            modalQRAbierto: false,
        };
        
    }

    componentDidMount() {
        
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    datosRegistroValidos() {
        const { registro, camposRequeridos } = this.state;

        let existenErrores = false
        if (!_valid(registro.url)) {
            camposRequeridos.push("URL");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), 3000);
        }

        return !existenErrores;
    }

    mostrarModalQR = registro => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro
            if (registro.url !== undefined && registro.url !== null) {
                this.apiRest.post('/generadorQR', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ modalQRAbierto: true, registro: registro, codigoQR: { url: registro.url } });                        
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });

                
            }
        }
    }

    ocultarModalQR = () => {
        this.setState({ modalQRAbierto: false, registro: {} });
    }

    generateImage = async () => {
        // Transforms the canvas into a base64 image
        let base64Image = document.getElementById('qrcode');
        const imageURL = base64Image.toDataURL('image/jpeg', 1.0);
        const a = document.createElement('a');
        a.href = imageURL;
        a.download = `QR.jpg`; 
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    render() {
        const { registro, colapsar, camposRequeridos, codigoQR } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Generador QR" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-qrcode-scan text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Generar Código QR</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, ingresa la dirección URL</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={12}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="url" className="form-label">
                                                                        URL
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.url}
                                                                        onChange={this.actualizarValores}
                                                                        name="url"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresar URL"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/solicitud') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" title="Codigo QR" onClick={() => this.mostrarModalQR(registro)}>
                                                        <MDBIcon icon="fas fa-play" /> {' '}
                                                        Generar
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                    </Container>
                </div>

                <Modal isOpen={this.state.modalQRAbierto} size="mm">
                    <ModalHeader>
                        Código QR 
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={12}>
                                <div id="articulo_qr">
                                    <QRcode 
                                        value = {codigoQR.url} 
                                        id = 'qrcode'
                                        size = {256}
                                        bgColor = {'#ffffff'}
                                        fgColor = {'#000000'}
                                        level = {'H'}
                                        includeMargin = {true}
                                        name = {codigoQR.url}
                                    />
                                    
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="codigo" className="form-label">
                                        La URL se registró en el sistema
                                    </Label>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.ocultarModalQR()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="dark" onClick={() => this.generateImage()}>
                            <MDBIcon icon="fas fa-print" /> {' '}
                            Descargar
                        </MDBBtn>                        
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}